import React from "react";
import { Grid } from "@mui/material";
import { Alert, TextField } from "@curves/ui-base";
import { UploadBox } from "@curves/ui-shared";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { isEmpty } from "@util/utils";
import { getMembershipSuspendFilePathName } from "@icoach/documents/document.util";
import { useMembershipSuspensionFormContext } from "@icoach/documents/membership/suspension/MembershipSuspensionFormContext";

const MembershipSuspensionAttachmentSection = () => {
	const {
		formData,
		formRef,
		isReadOnly,
		handleFileChange,
	} = useMembershipSuspensionFormContext();

	const {
		plugIns = {},
		isCompleteContract,
		leaveReason,
		hasDeviceOrder,
	} = formData;

	const fileName = isReadOnly && !isEmpty(plugIns) ? getMembershipSuspendFilePathName(plugIns.path) : "";

	return (
		<>
			{isCompleteContract && !isReadOnly && (
				<FieldGroup label="銷假原因" required>
					<Grid item xs={12}>
						<TextField
							ref={el => (formRef.current.leaveReason = el)}
							defaultValue={leaveReason}
							rows={6}
							readOnly={isReadOnly}
							multiline
							required
							fullWidth
						/>
					</Grid>
				</FieldGroup>
			)}

			<FieldGroup label="茲附證明">
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={6}>
							<UploadBox
								defaultFile={plugIns.path ? { url: plugIns.path, name: fileName } : null}
								onFileChange={handleFileChange}
								fileExtensions={["jpg", "png", "bmp", "jpeg"]}
								readOnly={isReadOnly}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="(字數限字100字)"
								ref={el => (formRef.current.note = el)}
								defaultValue={plugIns.note || null}
								maxLength={100}
								readOnly={isReadOnly}
								multiline
								fullWidth
								rows={4}
							/>
						</Grid>
					</Grid>
				</Grid>
			</FieldGroup>

			{hasDeviceOrder && (
				<FieldGroup label="智能裝置">
					<Grid item xs={12}>
						<Alert severity="info" variant="filled" color="info" className="alert-justify-content-start">
							當您申請暫停會籍時，您的 智能系統租用服務也將一併暫停。
							<br />
							在暫停期間，智能系統無法進行資料同步與日常監測，並會自動於會籍恢復當日重新啟用。
							<br />
							請您確認並知悉，智能系統租用時間將不會額外延長，使用期計算將如實依照原訂合約結束日為準。
						</Alert>
					</Grid>
				</FieldGroup>
			)}
		</>
	);
};

export default MembershipSuspensionAttachmentSection;